import React, { useState, useRef } from 'react';
// src/jsx/layout/dynamic-sidebar.jsx
// src/jsx/components/admin/roles-management/ViewRoles.jsx
import Sidebar from '../../../../components/layout/navigation/sidebar/DynamicSidebar';
import Header from '../../../../components/layout/headers/Header';
import BankingDetailsTable from './BankingDetailsTable.jsx';


const UserRoles = ()=>{


    return (
        <>
        <Header />
        <Sidebar />
        <div className="content-body">
            <div className="container">
                <div className="row">
                    <div className="col-xxl-12">
                        <BankingDetailsTable />
                    </div>
                </div>
            </div>
        </div> 
        </>
    )
}

export default UserRoles;